<mat-toolbar>
  <div class="left">
    @if (backButtonLink !== null) {
      <div class="back-button-container">
        <button mat-icon-button (click)="goBack()">
          <mat-icon>chevron_left</mat-icon>
        </button>
      </div>
    } @else {
      <div class="spacer"></div>
    }
    <div class="rows">
      <div class="title-row">
        <div class="title">{{ title }}</div>
        @if (meetingId !== null) {
          <span class="meeting-id">{{ meetingId }}</span>
          <button
            mat-icon-button
            class="copy-id-button"
            [cdkCopyToClipboard]="meetingId.toString()"
            (cdkCopyToClipboardCopied)="onIdCopied()"
            [matTooltip]="'COMMON.COPY' | translate"
          >
            <mat-icon>content_copy</mat-icon>
          </button>
        }
        @if (showSupportButton) {
          @if (currentUser$ | async; as user) {
            @if (user.role === 'SUPPORT') {
              <button mat-icon-button class="support-button" (click)="navigateToSupportView()">
                <mat-icon fontSet="material-symbols-outlined">admin_panel_settings</mat-icon>
              </button>
            }
          }
        }
      </div>
      <ng-content select=".details"></ng-content>
    </div>
  </div>
  <div class="actions">
    <ng-content select=".actions"></ng-content>
  </div>
</mat-toolbar>
